// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { useLocalMessage } from '@Helpers/locale';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement } from 'react';

import './ActionRequiredButton.scss';

interface ActionRequiredButtonProps {
    onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
    className?: string;
}

const ActionRequiredButton = ({ onClick, className }: ActionRequiredButtonProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <THTooltip title={i('task.actionRequired.tooltip')}>
            <ICONS.WarningTwoTone
                twoToneColor="#fc2c03"
                className={classList(className, { 'action-required-button__clickable': !!onClick })}
                onClick={onClick}
            />
        </THTooltip>
    );
};

export default ActionRequiredButton;
